var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMiro = function SvgMiro(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2274_200071)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFD02F",
    d: "M3 4h33v33H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#050038",
    d: "M25.487 7.4h-3.523l3.127 4.847L18.48 7.4h-3.523l3.127 6.352L11.473 7.4H7.95l3.076 8.2-3.076 16h3.523l6.611-17.156L14.957 31.6h3.523l6.611-18.66-3.127 18.66h3.523l6.663-20.497z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2274_200071"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    x: 3,
    y: 3,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgMiro;